import { Country } from '@/shared/api';
import { ICountry } from '@/shared/lib';

export const serializeCountry = (country: Country): ICountry => {
  return {
    id: country.id,
    name: country.item?.name ?? '',
    code: country.item?.code ?? '',
    iso: country.item?.code ?? '',
    alpha3: country.alpha3,
    phoneCode: country.phoneCode,
    mask: country.phoneTemplate,
  };
};
